<div class="tw-flex tw-flex-col tw-h-full tw-w-full">
    <div class="tw-flex-none" [class.tw-pointer-events-none]="isNavigating || isLoading">
        @if(modulePath){
            <app-fidelity-module-tabs
                [getTabChange]="tabChange"
                (tabPanelChange)="changeTab($event)"
            >
            </app-fidelity-module-tabs>
        }
        @else {
            <div appUpgradeUiView></div>
        }
    </div>


    <div class="tw-flex-1 tw-min-h-0 tw-relative">
        
        @if (isNavigating || isLoading) {
            <div class="tw-fixed tw-inset-0 tw-z-[9999] tw-cursor-wait tw-bg-transparent">
            </div>
        }

        <div class="tw-h-full tw-overflow-y-auto">
            @if (tabActive === 'campaigns') {
                <app-fidelity-campaigns />
            }
            @if (tabActive === 'rules') {
                <app-fidelity-rules />
            }
            @if (tabActive === 'prizes') {
                <app-fidelity-prizes />
            }
        </div>
    </div>
</div>